<template>
  <div class="bg-white p-2 border rounded shadow-sm">
    <div class="h-full">
      <div class="w-full mb-2">
        <button v-on:click="updateVenue"
                class="py-2  px-4 bg-teal-500 hover:bg-teal-700  text-white hover:border-transparent rounded-sm">
          Update Layout
        </button>
      </div>
      <gmap-map @click="createZone" @zoom_changed="zoomChanged" @center_changed="centerChanged" :options="options"
                :rotateControl="true"
                :center="center" :zoom="zoom" style="width:100%;  height: 700px;">
        <gmap-marker :key="index" v-for="(m, index) in markers" @dragend="mapAp($event, m.id)" :draggable="true"
                     :position="m.position" :label="m.label" @click="center=m.position"/>
        <gmap-polygon :paths="paths" :editable="true" @paths_changed="updateEdited($event)"/>
      </gmap-map>
    </div>
  </div>
</template>

<script>
import GraphQl from "@/services/graphql.service";

export default {
  name: "Maps",
  data() {
    return {
      venue: Object,
      zoom: 19,
      center: {lat: -1.2649773, lng: 36.8029781},
      places: [],
      venues: [],
      currentPlace: null,
      edited: null,
      paths: [],
      markers: [],
      newCenter: Object,
      options: {
        styles: [
          {
            featureType: "poi",
            stylers: [
              {
                visibility: "off"
              }
            ]
          }
        ]
      },
    }
  },
  props: {
    venueId: String,
  },
  computed: {},
  mounted() {
    this.geolocate()
    this.stats();
  },
  methods: {
    zoomChanged(newZoom) {
      this.zoom = newZoom
    },
    centerChanged(newCenter) {
      this.newCenter.lat = newCenter.lat()
      this.newCenter.lng = newCenter.lng()
    },
    updateEdited(mvcArray) {
      let paths = [];
      for (let i = 0; i < mvcArray.getLength(); i++) {
        let path = [];
        for (let j = 0; j < mvcArray.getAt(i).getLength(); j++) {
          let point = mvcArray.getAt(i).getAt(j);
          path.push({lat: point.lat(), lng: point.lng()});
        }
        paths.push(path);
      }
      this.edited = paths;
    },
    createZone(place) {
      let create = confirm("Create a new zone. Once a zone has been added, it can not be deleted after saving.");
      if (create) {
        let path = [
          {
            lat: place.latLng.lat(),
            lng: place.latLng.lng()
          },
          {
            lat: place.latLng.lat(),
            lng: place.latLng.lng() + .001
          }, {
            lat: place.latLng.lat() - .001,
            lng: place.latLng.lng() + .001
          },
          {
            lat: place.latLng.lat() - .001,
            lng: place.latLng.lng()
          }];
        this.paths.push(path);
      }
    },
    geolocate: function () {
      navigator.geolocation.getCurrentPosition(position => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
      });
    },

    stats() {
      GraphQl.sendRequest('{venue(id:"' + this.venueId + '") {name organization_id layout_polygon map_zoom lat lng id accessPoints{id name lat lng}}}')
          .then(response => {
            this.venue = response.venue;
            this.paths = JSON.parse(this.venue.layout_polygon) || this.paths;
            this.zoom = this.venue.map_zoom || this.zoom;
            this.center.lat = this.venue.lat || this.center.lat;
            this.center.lng = this.venue.lng || this.center.lng;
            this.venue.accessPoints.forEach((ap) => {
              this.markers.push({
                position: {
                  lat: ap.lat || this.center.lat,
                  lng: ap.lng || this.center.lng
                },
                id: ap.id,
                label: ap.name,
                icon: 'https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png'
              });
            });
          })
    },

    updateVenue() {
      let params = {
        map_zoom: this.zoom,
        name: this.venue.name,
        organization_id: this.venue.organization_id,
        layout_polygon: JSON.stringify(this.edited),
        lat: this.newCenter.lat || this.center.lat,
        lng: this.newCenter.lng || this.center.lng
      };
      this.axios.put(process.env.VUE_APP_SERVER_URL + '/api/v1/venues/' + this.venueId, params)
          .then(() => {
          }).catch(() => {
      });
    },
    mapAp(apCoord, apId) {
      let params = {
        lat: apCoord.latLng.lat(),
        lng: apCoord.latLng.lng()
      };
      this.axios.put(process.env.VUE_APP_SERVER_URL + '/api/v1/access_points/map/' + apId, params)
          .then(() => {
          }).catch(() => {
      });
    }
  }
}
</script>

<style scoped>

</style>